import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const VIDEO_MOBILE = 'https://cdn.orqafpv.com/website/hero_vertical_hd.mp4';
const VIDEO_DESKTOP = 'https://cdn.orqafpv.com/website/hero.mp4';

interface VideoProps {
  isMobile: boolean;
}

export const LandingWithVideo = ({ isMobile }: VideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [isMobile]);

  return (
    <section className="newhomepage-hero-section">
      <div className="newhomepage-hero-wrapper">
        <video
          ref={videoRef}
          className="newhomepage-hero-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source
            src={isMobile ? VIDEO_MOBILE : VIDEO_DESKTOP}
            type="video/mp4"
          />
        </video>

        <div className="newhomepage-hero-content">
          <div className="newhomepage-hero-titles">
            <h1 className="newhomepage-hero-subtitle">
              WELCOME TO THE NEW FRONTIER
            </h1>
            <h2 className="newhomepage-hero-title">
              <span className="newhomepage-hero-title-span">EVERY MISSION</span>{' '}
              <span className="newhomepage-hero-title-span">MATTERS</span>
            </h2>
          </div>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 628 9"
            fill="none"
            className="newhomepage-hero-line"
          >
            <g filter="url(#filter0_d_5838_5638)">
              <path
                d="M0 8H628"
                stroke="url(#paint0_linear_5838_5638)"
                shapeRendering="crispEdges"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_5838_5638"
                x="0"
                y="0"
                width="628"
                height="9"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="2" dy="2" /> <feGaussianBlur stdDeviation="3" />{' '}
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_5838_5638"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_5838_5638"
                  result="shape"
                />
              </filter>
              <linearGradient
                id="paint0_linear_5838_5638"
                x1="0"
                y1="12"
                x2="628"
                y2="12"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.163462" stopColor="#EE2737" />
                <stop offset="0.711538" stopColor="#EE2737" />
                <stop offset="1" stopColor="#EE2737" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>

          <div className="newhomepage-hero-description-button">
            <p className="newhomepage-hero-description">
              <span className="newhomepage-hero-description-span">
                We build drones that go where others can't. Our systems command
                every environment, from confined spaces to open skies, turning
                impossible missions into reality thanks to their unrivalled
                performance. When it matters, Orqa delivers.
              </span>
              <br />
              <span className="newhomepage-hero-description-span">
                Follow us into the new.
              </span>
            </p>
            <div className="dreamX__discover--button">
              <Link
                to="/products/mrm2-10"
                rel="noopener noreferrer"
                className="btn btn--primary btn--med"
                onMouseDown={event => event.preventDefault()}
              >
                try orqa
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
